import { render, staticRenderFns } from "./OrgDetails_new.vue?vue&type=template&id=9e594ea2&"
import script from "./OrgDetails_new.vue?vue&type=script&lang=js&"
export * from "./OrgDetails_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports